export const sidebarArticles = [
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg 2x',
    },
    title: "LARQ | World's First Self-cleaning Water Bottle‎",
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
      },
      name: 'Kate Segelson',
    },
    date: '04 Aug',
    tags: ['larq', 'bottle', 'shop', 'drinks', 'eco', 'self washing'],
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg 2x',
    },
    title: 'NIKE Online Store launches the website‎',
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
      },
      name: 'Jack Smith',
    },
    date: '04 Aug',
    tags: ['nike', 'sport', 'shop', 'training'],
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg 2x',
    },
    title: 'Adidas will release your favourite shoes',
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
      },
      name: 'Akachi Luccini',
    },
    date: '04 Aug',
    tags: ['adidas', 'sport', 'shop', 'training'],
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg 2x',
    },
    title: 'Simple approach to Australian cafe',
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
      },
      name: 'Veronica Adams',
    },
    date: '04 Aug',
    tags: ['coffee', 'cups', 'morning coffee', 'breakfast'],
  },
];

export const similarStories = [
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg 2x',
    },
    title: 'Adidas will release your favourite shoes',
    subtitle:
      'Get your favourite adidas shoes, clothing & accessories at the official website! adidas Training.',
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
      },
      name: 'Akachi Luccini',
    },
    date: '04 Aug',
    tags: ['adidas', 'sport', 'shop', 'training'],
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg 2x',
    },
    title: 'NIKE Online Store launches the website‎',
    subtitle:
      'Be Your Best Every Time With Nike Shoes And Clothing. Shop Online. The Official Website. Home Of Everything Nike. Shop The Latest Releases Today! Types: Shoes, Tops.',
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
      },
      name: 'Jack Smith',
    },
    date: '04 Aug',
    tags: ['nike', 'sport', 'shop', 'training'],
  },
  {
    cover: {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg 2x',
    },
    title: "LARQ | World's First Self-cleaning Water Bottle‎",
    subtitle:
      "A self-cleaning water bottle that'll help you reach your hydration goal. Neutralizes up to 99%* of harmful, odor-causing bacteria using UV-C light.",
    author: {
      photo: {
        src: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson.jpg',
        srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/kate-segelson@2x.jpg 2x',
      },
      name: 'Kate Segelson',
    },
    date: '04 Aug',
    tags: ['larq', 'bottle', 'shop', 'drinks', 'eco', 'self washing'],
  },
];

export const content = {
  headline:
    'Barbecue party tips can help a host put together an extraordinary event for family and friends. Eating outdoors is a favorite pastime enjoyed by everyone and planning the event can help make it more memorable and stress-free for the host. Big or small, a barbecue party requires an adequate amount of planning and preparation to ensure that everything is laid out properly. It is advisable to plan the event around a theme in order to create a focal point for the barbecue party. This way, all aspects of the party such as the food, games and decorations can be fashioned around a central theme. Favorite themes for barbecue parties include a Hawaiian motif, nostalgic seventies get-together, or, if you are near the sea, opt for a beach bbq party!',
  quote:
    "Keep track of what's happening with your data, change permissions, against your data anywhere in the world.",
  text1:
    'Barbecue party tips can help a host put together an extraordinary event for family and friends. Eating outdoors is a favorite pastime enjoyed by everyone and planning the event can help make it more memorable and stress-free for the host. Big or small, a barbecue party requires an adequate amount of planning and preparation to ensure that everything is laid out properly.',
  text2:
    'Barbecue party tips can help a host put together an extraordinary event for family and friends. Eating outdoors is a favorite pastime enjoyed by everyone and planning the event can help make it more memorable and stress-free for the host. Big or small, a barbecue party requires an adequate amount of planning and preparation to ensure that everything is laid out properly.',
  title: 'Adidas will release your favourite shoes',
  subtitle:
    'Get your favourite Adidas shoes, clothing & accessories at the official website! Adidas Training.',
  author: {
    photo: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    name: 'Jack Smith',
    date: 'May 20, 2019',
  },
  cover: {
    src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover2.jpg 2x',
  },
  images: [
    {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover4.jpg 2x',
      cols: 2,
    },
    {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover3.jpg 2x',
      cols: 1,
    },
    {
      src: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/blog/cover1.jpg 2x',
      cols: 1,
    },
  ],
};
